<template>
  <section :class="this.$Base.checkSysteam() == 'MOBILE' ? 'minfo' : 'info'">
    <!-- header -->
    <div
      v-if="this.$Base.checkSysteam() == 'MOBILE'"
      :class="this.$Base.checkSysteam() == 'MOBILE' ? 'mheader' : 'header'"
    >
      <div class="nav">
        <img src="../../assets/nav.png" alt="" />
      </div>
      <div class="logo">
        <img src="../../assets/game-logo.png" alt="" />
      </div>
    </div>
    <div class="header" v-if="this.$Base.checkSysteam() == 'PC'">
      <div class="header-in">
        <div class="head-left">
          <div class="logo">
            <img src="../../assets/game-logo.png" alt="" />
          </div>
        </div>
      </div>
    </div>
    <!-- 内容 -->
    <div class="infos">
      <h2>楓之谷R儲值流程</h2>
      <div class="infoCenter">
        <p>1. 登錄遊戲，選擇<i>特惠</i>商城</p>
        <img src="../../assets/info/1.png" />
        <p>2. 選擇任意檔位禮包</p>
        <img src="../../assets/info/2.png" />
        <p>3. 跳轉至儲值中心，選擇相應的儲值方式</p>
        <img src="../../assets/info/3.png" />
        <p>4-1. 【銀行匯款】：複製銀行帳號至信托銀行進行轉帳</p>
        <img src="../../assets/info/4.png" />
        <p>
          4-2.
          【WEB-ATM】：選擇相應銀行後選擇彩鑽檔位，確認後跳轉至相應銀行界面支付進行交易
        </p>
        <img src="../../assets/info/5.png" />
        <p>
          4-3.
          【信用卡】：跳轉至協力廠商支付，填寫購買資訊，跳轉至銀行介面進行交易
        </p>
        <img src="../../assets/info/6.png" />
        <p>
          4-4.
          【支付寶】：跳轉至協力廠商支付，填寫購買資訊，跳轉至支付寶介面進行交易
        </p>
        <img src="../../assets/info/7.png" />
        <p>
          4-5.
          【Mycard會員扣點】：跳轉至Mycard會員扣點介面，填寫帳號資訊進行登錄，填寫支付密碼完成付款
        </p>
        <img src="../../assets/info/8.png" />
        <p>4-6. 【電信業者】：選擇相應儲值方式，填寫支付資訊，完成付款流程</p>
        <img src="../../assets/info/9.png" />
        <img src="../../assets/info/10.png" width="880px" />
      </div>
    </div>
    <!-- 底部 -->
    <rastar-footer></rastar-footer>
  </section>
</template>

<script>
import rastarFooter from "./../../components/footer/template.vue";
export default {
  name: "ldy",
  data() {
    return {
      urlData: null,
      isMsgVal: 0,
      msgFormSon: "wo shi ceshi",
    };
  },
  props: ["appId", "pId", "mdId", "ukey", "msgVal"],
  components: {
    rastarFooter,
  },
  methods: {},
  created() {},
};
</script>

<style lang="scss" src="./style.scss" scoped></style>
